import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_USER}/user`;
const securl = `${process.env.REACT_APP_API_URL_USER}`;
export async function getMe(params?: any) {
  return client.post({
    url: `${url}/get`,
    form: params
  });
}

export async function getResource(res_id: string) {
  return client.post({
    url: `${url}/resource`,
    form: { res_id }
  });
}

// 更新用戶信息
export const updateUserMsg = async ({ first_name, sex, language }: any) =>
  client.post({
    url: `${url}/update`,
    form: {
      first_name,
      sex,
      language
    }
  });

// 上傳用戶頭像
export const getUploadPermit = async (
  i_controller: any,
  i_action: any,
  i_fileMeta: any,
  i_formData = {}
) => {
  const meta = {
    lastModified: i_fileMeta.lastModified,
    lastModifiedDate: i_fileMeta.lastModifiedDate,
    name: i_fileMeta.name,
    size: i_fileMeta.size,
    type: i_fileMeta.type
  };
  const formData = { meta, ...i_formData };
  return client.post({
    url: `${securl}/upload/token/${i_controller}/${i_action}`,
    form: formData
  });
};

// 得到更新頭像的權限，返回值裡面有sign_url地址
export const getProfilePermit = async (i_fileMeta: any) =>
  getUploadPermit('user', 'profile', i_fileMeta);

// 上傳頭像調用的第二個接口
export async function uploadProfile(_permit: any, file: any) {
  return client.uploadOSS(_permit, file);
}

// 更新預設的背景頭像
export const updateAvatars = async (params: any) => {
  return client.post({
    url: `${url}/update_bg`,
    form: {
      bg_id: params
    }
  });
};

// 修改登錄的密碼
export async function updatePassword(params: any) {
  return client.post({
    url: `${url}/update_password`,
    form: {
      old_password: params.oldPassword,
      password: params.newPassword
    }
  });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  updateUserMsg,
  updateAvatars
};
